import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import AssetType from './AssetType'
import TickerSearch from './TickerSearch'

import style from './style.sass'

@inject('store') @observer
class MainSettings extends Component {
  render() {
    const {analysis} = this.props.store
    return(
      <div styleName='wrapper'>
        <AssetType/>
        <TickerSearch/>
        <div styleName='ticker-display'>
          <span styleName='ticker'>
            {analysis.tickerName?.replace('CRYPTO-', '')}
          </span>
          <span styleName='company'>
            {analysis.company}
          </span>
        </div>
        {/* <div styleName='settings'>
          <button/>
        </div>
        <div styleName='save'>
          <button>
            <span styleName='icon'/>
            <span styleName='text'>Save</span>
          </button>
        </div> */}
      </div>
    )
  }
}

export default MainSettings
